
<template>
  <ClicColInterno :cp="cp" :key="componentKey">
  <div 
  v-if="visible" 
  class="kanban-container"
  :id="$utils.getComponentID(cp.id)"
  >
    <div class="kanban-board">
      <div 
        v-for="coluna in kanbanColumns" 
        :key="coluna.name" 
        class="kanban-column"
      >
        <div class="column-header">
          <h3>{{ coluna.label }}</h3>
          <span class="count badge">{{ coluna.tasks.length }}</span>
        </div>

        <draggable
          v-model="coluna.tasks"
          group="kanban"
          @change="(event) => onChange(event, coluna.name)"
          class="drag-area custom-scrollbar"
          ghost-class="ghost-card"
          drag-class="dragging-card"
          :animation="200"
        >
        <div 
            v-for="element in coluna.tasks" 
            :key="element.taskId" 
            class="kanban-card"
            @click="openTask(element)"
          >
            <div class="status-indicator" :style="{ backgroundColor: element.color || '#ededed' }"></div>            
            
            <div class="card-content">
              
              <div class="d-flex justify-content-between align-items-start mb-2">
                  <p class="card-title m-0 pr-2">{{ element.title || "" }}</p>

                  <div class="card-actions" @click.stop v-if="allowRemove">
                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none p-0 text-muted" no-caret right>
                        <template #button-content>
                            <ClicIconInterno iconName="md-morevert" scale="1.1" style="color: #6b778c" />
                        </template>
                        
                        <b-dropdown-item @click="deleteTask(coluna, element)" >
                            <div class="d-flex align-items-center text-danger">
                            <ClicIconInterno iconName="md-delete" class="mr-2" />
                            <span>Excluir</span>
                            </div>
                        </b-dropdown-item>
                    </b-dropdown>
                  </div>
              </div>

              <template v-if="getSlotModal()">
                <MotorS :cp="cp" :childrens="getSlotModal()" :idTela="idTela"
                 :state="{ row: {item: element, index: element.taskId}, parent: { ...cp}}"

                 />
              </template>

            </div>
          </div>
        </draggable>

        <div class="column-footer" v-if="allowAdd">
          <div v-if="addingToColumn === coluna.name" class="add-card-form">
            <textarea 
              v-model="newCardTitle" 
              class="add-card-input" 
              placeholder="Escreva o título da tarefa..."
              @keydown.enter.exact.prevent="addTaskToColumn(coluna)"
              @keydown.esc="cancelAdd"
              ref="newCardInput"
              rows="2"
            ></textarea>
            <div class="add-actions">
              <button class="btn-save" @click="addTaskToColumn(coluna)">Adicionar</button>
              
              <button class="btn-cancel" @click="cancelAdd">
                <ClicIconInterno iconName="md-close" />
              </button>
            </div>
          </div>
          
          <button v-else class="btn-add-ghost" @click="showAddInput(coluna.name)">
            <ClicIconInterno iconName="md-add" class="mr-1" />
            Adicionar cartão
          </button>
        </div>      
      </div>
    </div>

  </div>
</ClicColInterno>
</template>

<script>
  import ComponentMixin from '../../core/ComponentMixin';
  import draggable from "vuedraggable";
  import { BDropdown, BDropdownItem } from 'bootstrap-vue';

  export default {
    name: 'ClicKanban',
    mixins: [ComponentMixin],
    components: {
      draggable,
      BDropdown,
      BDropdownItem,
    },
    data() {
      return {
        tasks: [],
        columns: [],
        kanbanColumns: [],
        showModal: false,
        selectedCard: null,
        addingToColumn: null,
        newCardTitle: '',
        public: {
          getData: this.getData,
          dataRefresh: this.dataRefresh,
          createTask: this.createTask,
          updateTask: this.updateTask,
          createTaskId: this.createTaskId
        }
      };
    },

    mounted() {
      this.initializeKanban();
    },
  
    methods: {
      initializeKanban() {
        this.kanbanColumns = this.columns.map(col => {
          return {
            name: col.name, 
            label: col.label, 
            // color: col.color || "#ededed", 
            color: "#ededed", 
            tasks: this.tasks.filter(b => b.status === col.name)
          };
        });
      },

      getData(){
        return {
          columns: this.columns,
          tasks: this.tasks,
        }
      },

      async dataRefresh(){
        this.tasks = await this.obterDados();
        this.initializeKanban();
        this.componentKey = this.$utils.getComponentID();
      },

      obterDados() {
        return new Promise((resolve, reject) => {
          //Futuramente implementar a lógica do axios
          resolve(this.tasks);       
        });
      },

      // ----- Eventos -----
      onChange(event, status) {
        if (event.added) {
          const item = event.added.element;
          item.status = status;

          const targetColumn = this.columns.find(c => c.name === status);
          if (targetColumn && targetColumn.color) {
            this.$set(item, 'color', targetColumn.color);
          }
        }

        if  (this.lodash.has(this.cp, 'events.change')) {
            this._execEvent('change', { event, status });
        }
      },
   
      openTask(task) {
        if  (this.lodash.has(this.cp, 'events.openTask')) {
            this._execEvent('openTask', { task });
        }
      },

      updateTask(targetTask = null) {        
        if (!targetTask) {
          console.warn("Nenhum card selecionado para salvar.");
          return;
        }

        const taskIndex = this.tasks.findIndex(t => t.taskId === targetTask.taskId);

        if (taskIndex > -1) {
            const taskToUpdate = this.tasks[taskIndex];

            if (targetTask) {
              Object.assign(taskToUpdate, targetTask);
            }

            this.$set(this.tasks, taskIndex, taskToUpdate);
            
        } else {
            console.error(`[ClicKanban] Tarefa com ID ${targetTask.taskId} não encontrada na lista.`);
        }
        
        if (this.lodash.has(this.cp, 'events.updateTask')) {
            let task = this.tasks[taskIndex];
            this._execEvent('updateTask', { targetTask, task });
        }
      },

      deleteTask(coluna, task) {
        const index = coluna.tasks.indexOf(task);
        if (index > -1) {
            coluna.tasks.splice(index, 1);
        }
        
        const mainIndex = this.tasks.findIndex(t => t.taskId === task.taskId);
        if (mainIndex > -1) {
            this.tasks.splice(mainIndex, 1);
        }

        if (this.lodash.has(this.cp, 'events.deleteTask')) {
          this._execEvent('deleteTask', { coluna, task });
        }
      },

      //Quando o card é criado pelo atalho da coluna
      addTaskToColumn(column) {
        if (!this.newCardTitle.trim()) {
          return;
        }
  
        const newCard = {
          taskId: this.createTaskId(), 
          title: this.newCardTitle.trim(),
          description: '', 
          status: column.name,
          priority: 'normal',
          createdAt: new Date().toISOString().split('T')[0], 
          responsible: this.getLoggedUser()
        };
  
        column.tasks.push(newCard);
        this.tasks.push(newCard);
  
        this.newCardTitle = '';
        
        this.$nextTick(() => {
           if(this.$refs.newCardInput && this.$refs.newCardInput[0]) {
              this.$refs.newCardInput[0].focus();
              this.$refs.newCardInput[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
           }
        });
        
      },

      createTask(task) {
        if (!task) return;

        if (!task.taskId) {
            task.taskId = this.createTaskId();
        }

        if (!task.status && this.columns.length > 0) {
            task.status = this.columns[0].name;
        }

        this.tasks.push(task);

        const targetColumn = this.kanbanColumns.find(c => c.name === task.status);
        
        if (targetColumn) {
            targetColumn.tasks.push(task);
        } else {
            console.warn(`[ClicKanban] Coluna '${task.status}' não encontrada. Recarregando.`);
            this.initializeKanban();
        }
        
        if  (this.lodash.has(this.cp, 'events.createTask')) {
            this._execEvent('createTask', { column, task });
        }
      },

      // ----- Métodos Auxiliares -----
      showAddInput(columnName) {
        this.addingToColumn = columnName;
        this.newCardTitle = '';
        this.$nextTick(() => {
          if(this.$refs.newCardInput && this.$refs.newCardInput[0]) {
            this.$refs.newCardInput[0].focus();
          }
        });
      },
      cancelAdd() {
        this.addingToColumn = null;
        this.newCardTitle = '';
      },
      createTaskId(){
        return `${Math.floor(Math.random() * 100000)}`
      },
    

      // ---- Getters e Setters ----
      getLoggedUser(){
        let dadosUsuarioLogadoWebStorage  = localStorage.getItem(`usuarioLogado`);
        let dadosUsuarioLogado            = this.stringToObject(dadosUsuarioLogadoWebStorage);
        return dadosUsuarioLogado || { fantasia: "Visitante" };
      },
      getStatusColor(statusName) {
        const col = this.columns.find(c => c.name === statusName);
        return col ? col.color : '#6c757d';
      },
      formatTitle(val) {
        if (!val) return '';
        return val.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      },
      stringToObject(string){
        try{
            return JSON.parse(string);
        }catch(_){
            return string;
        }
      },
      getSlotModal() {
        let row = this.$getSlot('card');
        return row
      },
    },
  };
  </script>





<style scoped>
  /* --- Container Principal --- */
  .kanban-container {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background-color: #f4f5f7;
    width: 100%;
    
    padding: 20px 0 20px 20px; 
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  
  /* --- Área do Kanban (Onde tudo acontece) --- */
  .kanban-board {
    display: flex;
    gap: 15px;
    height: auto;         
    max-height: 1000px;     
    
    align-items: flex-start; 
    overflow: visible;
    
    padding-right: 20px;
    padding-bottom: 10px;
  
    -webkit-overflow-scrolling: touch;
    /* scroll-snap-type: x mandatory;  */
  }
  
  /* --- Estilização da Barra de Rolagem--- */
  .kanban-board::-webkit-scrollbar {
    width: 10px; 
    height: 10px;
    display: block;
  }
  
  .kanban-board::-webkit-scrollbar-track {
    background: rgba(9, 30, 66, 0.05);
    border-radius: 10px;
  }
  
  .kanban-board::-webkit-scrollbar-corner {
    background: transparent;
  }
  
  .kanban-board::-webkit-scrollbar-thumb {
    background-color: #c1c7d0;
    border-radius: 10px;
    border: 2px solid #f4f5f7;
  }
  
  .kanban-board::-webkit-scrollbar-thumb:hover {
    background-color: #a0a6b1;
  }
  
  /* --- Colunas --- */
  .kanban-column {
    background-color: #ebecf0;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    max-height: 70vh;
    overflow-y: scroll;
    height: auto;  
    min-width: 280px;
    width: 280px;
    flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    /* scroll-snap-align: start; */
  }
  
  .column-header {
    padding: 16px 12px 12px 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #172b4d;
    position: sticky;
    top: 0;
    z-index: 10; 
    background-color: #ebecf0;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  
  .column-header h3 { margin: 0; font-size: 1.1rem; }
  
  .badge {
    background-color: rgba(9, 30, 66, 0.08);
    color: #172b4d;
    border-radius: 16px;
    padding: 4px 10px;
    font-size: 0.85rem;
    font-weight: bold;
  }
  
  .drag-area {
    margin: 0px 5px;
    padding: 8px 4px;
    /* Garante uma área de drop utilizável mesmo com a coluna vazia */
    min-height: 80px;
    flex-grow: 1;
  }
  
  
.kanban-card {
  background-color: white;
  margin-bottom: 12px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(9, 30, 66, 0.13); 
  cursor: grab;
  position: relative;
  overflow: hidden;
  display: flex;
  border: 1px solid rgba(9, 30, 66, 0.08);
}

.kanban-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(9, 30, 66, 0.13);
}

.status-indicator { width: 4px; flex-shrink: 0; }

.card-content { padding: 12px 12px 8px 12px; flex-grow: 1; display: flex; flex-direction: column; }

.card-title { 
  margin: 0 0 8px 0; 
  font-weight: 500; 
  color: #172b4d; 
  line-height: 1.4; 
  font-size: 0.95rem;
}

.desc-lines {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.card-footer-row {
  display: flex;
  align-items: center;
  gap: 6px; /* Espaço entre os ícones */
  margin-top: auto; /* Empurra para baixo se o card for alto */
}

.icon-box {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #dfe1e6; 
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e6c84;
}



.mb-2 { margin-bottom: 8px; }
.mr-1 { margin-right: 4px; }
  .kanban-card:hover { transform: translateY(-2px); box-shadow: 0 4px 8px rgba(9, 30, 66, 0.13); }
  .kanban-card:active { cursor: grabbing; }
  
  .status-indicator { width: 4px; flex-shrink: 0; }
  
  .card-content { padding: 12px; flex-grow: 1; }
  .card-title { margin: 0 0 12px 0; font-weight: 500; color: #172b4d; line-height: 1.4; }
  .card-footer { display: flex; justify-content: space-between; align-items: center; color: #6b778c; font-size: 0.85rem; }
  .more-icon { font-weight: bold; visibility: hidden; }
  .kanban-card:hover .more-icon { visibility: visible; }
  
  .ghost-card { background-color: #e4f0f6; border: 2px dashed #0079bf; opacity: 0.7; box-shadow: none; }
  .dragging-card { opacity: 1; transform: rotate(2deg); box-shadow: 0 10px 20px rgba(9, 30, 66, 0.25); }
  
  
  @media (max-width: 768px) {
    .kanban-container {
      padding: 10px 0 10px 10px;
    }
  
    .kanban-column {
      width: 80vw;
      min-width: 80vw;
    }
    
    .kanban-board {
       max-height: 80vh;
    }
  }
  

  .column-footer {
    padding: 8px;
    margin-top: 4px;
  }

  .btn-add-ghost {
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #5e6c84;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 6px 8px;
    text-align: left;
    width: 100%;
    font-size: 0.9rem;
    transition: background 0.2s;
  }

  .btn-add-ghost:hover {
    background-color: rgba(9, 30, 66, 0.08);
    color: #172b4d;
    text-decoration: none;
  }

  .plus-icon {
    margin-right: 6px;
    font-size: 1.2rem;
    line-height: 1;
  }

  /* Área do Formulário */
  .add-card-form {
    background-color: transparent;
  }

  .add-card-input {
    width: 100%;
    border: none;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(9, 30, 66, 0.13);
    padding: 8px 10px;
    margin-bottom: 8px;
    font-family: inherit;
    font-size: 0.9rem;
    resize: none; 
    min-height: 54px;
    display: block;
    box-sizing: border-box;
    outline: 2px solid transparent;
  }
  
  .add-card-input:focus {
    outline: 2px solid #0065ff;
  }

  .add-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-save {
    background-color: #0065ff;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
  }

  .btn-save:hover {
    background-color: #0052cc;
  }

  .btn-cancel {
    background: none;
    border: none;
    color: #6b778c;
    font-size: 1.5rem;
    cursor: pointer;
    line-height: 1;
    padding: 0 8px;
    display: flex;
    align-items: center;
  }

 





  </style>
